import { ResourceCapacity, RetrieveCapacityRequest } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type Response = {
  content: ResourceCapacity[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
};

function getCapacity(httpClient: HttpClient) {
  return (request: RetrieveCapacityRequest) =>
    httpClient.sendHttpRequest<Response>({
      endpoint: "/capacity-planning/capacity",
      method: HttpMethods.POST,
      data: {
        from: request.from,
        to: request.to,
        granularity: request.granularity,
        page: request.page,
        size: request.size,
        ...(request.filter && {
          filter: {
            resources: request.filter.resources?.map(({ uuid }) => uuid),
            resourceTags: request.filter.resourceTags,
            groups: request.filter.groups?.map(({ uuid }) => uuid),
            roles: request.filter.roles?.map(({ uuid }) => uuid),
          },
        }),
        ...(request.sort && { sort: request.sort }),
      },
    });
}

export { getCapacity };
